import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CarsysService {

  constructor(private httpClient: HttpClient) { }

  enviarArquivo(mes, ano, arquivo): Promise<{'msg':String, 'success':boolean}>{
    let form = new FormData();
    form.append('mes', mes);
    form.append('ano', ano);
    form.append('uploadFile', arquivo);
    return this.httpClient.post<{'msg':String, 'success':boolean}>(environment.wsUrl + 'laudo/uploadTabelaCarsys',form, {
      params: {ignore: 'content-type'}
    }).toPromise();
  }

  listaRelatorios(params): Promise<{total:number, lista:[]}>{
    let data = {...params};
    data.sorting = {};

    for (const i in params.sorting) {
      if(params.sorting[i] != "") {
        data.sorting[i] = params.sorting[i];
      }
    }

    return this.httpClient.post<{total:number, lista:[]}>(environment.wsUrl + 'laudo/listaLaudoCarsys',data, {
      params: {ignore: 'loading'}
    }).pipe(map(r=> ({total: r.total || 0, lista: r.lista || []}))).toPromise();
    
  }
  
  excluirLaudo(laudo) {
    return this.httpClient.post<any>(environment.wsUrl + 'laudo/deletarLaudoCarsys',laudo, {}).toPromise();
  }


  getListaTipoLaudo() {
    return this.httpClient.get<{ id:string, nome:string, descricao:string }[]>(environment.wsUrl + 'laudo/listaTipoLaudoCarsys/').toPromise();
  }

  getTipoLaudo(id) {
    return this.httpClient.get<any>(environment.wsUrl + 'laudo/listaTipoLaudoCarsys/', id).toPromise();
  }

  cadastrarTipoLaudo(formulario, justificativa) {
    return this.httpClient.post<any>(environment.wsUrl + 'laudo/criarTipoLaudo', formulario, { headers: {justificativa}}).toPromise();
  }

  editarTipoLaudo(laudo, justificativa) {
    return this.httpClient.post<any>(environment.wsUrl + 'laudo/atualizarTipoLaudo',laudo, { headers: {justificativa}}).toPromise();
  }

  // COMENTADO CÓDIGO ABAIXO POIS URL NO SERVIDOR AINDA NÃO EXISTE ....

  // excluirTipoLaudo(id, justificativa) {
  //   return this.httpClient.post<any>(environment.wsUrl + 'laudo/excluirTipoLaudo', id, { headers: {justificativa}}).toPromise();
  // }
}
